import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { editMember, savelinked, editLinked } from "../store/slices/userSlice";
import { useDispatch } from "react-redux"; // Import useDispatch
import { usStates } from "../services/states";

// Set the root element for accessibility
Modal.setAppElement("#root");


// Convert DB format (yyyy-MM-dd HH:mm:ss) -> MM-dd-yyyy
const formatDateForDisplay = (dbDate) => {
    if (!dbDate) return "";
    const date = new Date(dbDate);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

const formatDateForDisplayForValidUpto = (dbDate) => {
    if (!dbDate) return "";
    const date = new Date(dbDate);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    debugger
    return `${year}-${month}-${day}`;
};

// Convert MM-dd-yyyy -> yyyy-MM-dd HH:mm:ss for DB
const formatDateForSave = (uiDate) => {
    if (!uiDate) return "";
    const [month, day, year] = uiDate.split("-");
    return `${year}-${month}-${day} 00:00:00`;
};

const formatDateForSaveValidUpto = (uiDate) => {
    if (!uiDate) return "";
    const [year, month, day] = uiDate.split("-");
    debugger
    return `${year}-${month}-${day}`;
};


function Membersmodal({ isModalOpen, setIsModalOpen, reloadData, selectedMember, primarymember, edit = false, type }) {
    const rolelist = ["user", "admin"];
    const dispatch = useDispatch(); // Initialize useDispatch

    const [formData, setFormData] = useState({
        id: 0,
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        addressline1: "",
        addressline2: "",
        addressline3: "",
        state: "",
        zipcode: "",
        join_date: "",
        role: "",
        validupto: "",
        primarymember: ""
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Effect to populate form data when a member is selected or primarymember changes
    // useEffect(() => {
    //     try {
    //         if (isModalOpen) {
    //             if (selectedMember) {
    //                 setFormData({
    //                     id: selectedMember.id || 0,
    //                     firstname: selectedMember.firstname || "",
    //                     lastname: selectedMember.lastname || "",
    //                     email: selectedMember.email || "",
    //                     mobile: selectedMember.mobile || "",
    //                     addressline1: selectedMember.addressline1 || "",
    //                     addressline2: selectedMember.addressline2 || "",
    //                     addressline3: selectedMember.addressline3 || "",
    //                     state: selectedMember.state || "",
    //                     zipcode: selectedMember.zipcode || "",
    //                     join_date: selectedMember.join_date || "",
    //                     role: selectedMember.role || "",
    //                     validupto: selectedMember.validupto_date || "",
    //                     primarymember: selectedMember.primarymember || ""
    //                 });
    //             } else {
    //                 setFormData({
    //                     id: 0,
    //                     firstname: "",
    //                     lastname: "",
    //                     email: "",
    //                     mobile: "",
    //                     addressline1: "",
    //                     addressline2: "",
    //                     addressline3: "",
    //                     state: "",
    //                     zipcode: "",
    //                     join_date: "",
    //                     role: "",
    //                     validupto: "",
    //                     primarymember: primarymember || ""
    //                 });
    //             }
    //             setError(null);
    //         }
    //     } catch (error) {
    //         console.error("useEffect error (selectedMember init):", error);
    //     }
    // }, [selectedMember, primarymember, isModalOpen]);


    useEffect(() => {
        if (isModalOpen) {
            if (selectedMember) {
                setFormData({
                    ...selectedMember,
                    join_date: formatDateForDisplay(selectedMember.join_date),
                    validupto: formatDateForDisplayForValidUpto(selectedMember.validupto_date),
                    primarymember: selectedMember.primarymember || "",
                    mobile: formatMobileForDisplay(selectedMember.mobile)
                });
            } else {
                setFormData({
                    id: 0,
                    firstname: "",
                    lastname: "",
                    email: "",
                    mobile: "",
                    addressline1: "",
                    addressline2: "",
                    addressline3: "",
                    state: "",
                    zipcode: "",
                    join_date: "",
                    role: "",
                    validupto: "",
                    primarymember: primarymember || ""
                });
            }
        }
    }, [selectedMember, primarymember, isModalOpen]);


    useEffect(() => {
        console.log("Form data:", formData);
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // setFormData((prev) => ({ ...prev, [name]: value }));
        if (name === "mobile") {
            // Remove all non-digit characters from the input
            const cleanedValue = value.replace(/\D/g, '');
            setFormData((prev) => ({ ...prev, [name]: cleanedValue }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const formatMobileForDisplay = (mobile) => {
        if (!mobile || mobile.length !== 10) return mobile;
        return `${mobile.substring(0, 3)}-${mobile.substring(3, 6)}-${mobile.substring(6, 10)}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const requiredFields = [
            "firstname", "lastname", "email", "mobile",
            "addressline1", "state", "zipcode"
        ];

        for (const field of requiredFields) {
            if (!formData[field]?.trim()) {
                setLoading(false);
                Swal.fire("Validation Error", `Please fill in the "${field}" field.`, "warning");
                return;
            }
        }

        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            setLoading(false);
            Swal.fire("Validation Error", "Please enter a valid email address.", "warning");
            return;
        }

        if (!/^\d{10}$/.test(formData.mobile)) {
            setLoading(false);
            Swal.fire("Validation Error", "Mobile number must be exactly 10 digits.", "warning");
            return;
        }

        try {
            let response;
            
            const payload = {
                ...formData,
                join_date: formatDateForSave(formData.join_date),
                validupto: formatDateForSaveValidUpto(formData.validupto)
            };

            delete payload.number;
            delete payload.validupto_date;
            delete payload.join_date;
            debugger

            if (selectedMember?.id) {
                response = type === "primary"
                    ? await editMember(payload)
                    : await editLinked(payload);
            } else {
                response = await savelinked(payload);
            }

            if (response?.status === 200) {
                Swal.fire("Success", `${selectedMember ? "Member updated" : "Member saved"} successfully!`, "success");
                reloadData();
                setIsModalOpen(false);
            } else {
                const errorMessage = response?.message || "Operation failed!";
                Swal.fire("Error", errorMessage, "error");
            }
        } catch (err) {
            console.error("Submission error:", err);
            Swal.fire("Error", "Something went wrong! Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);
    //     setError(null);

    //     // Client-side validation
    //     const requiredFields = [
    //         "firstname", "lastname", "email", "mobile",
    //         "addressline1", "state", "zipcode"
    //     ];

    //     for (const field of requiredFields) {
    //         if (!formData[field]) {
    //             setLoading(false);
    //             Swal.fire("Validation Error", `Please fill in the ${field.replace(/([A-Z])/g, ' $1').toLowerCase()} field.`, "warning");
    //             return;
    //         }
    //     }

    //     // Basic email validation
    //     if (!/\S+@\S+\.\S+/.test(formData.email)) {
    //         setLoading(false);
    //         Swal.fire("Validation Error", "Please enter a valid email address.", "warning");
    //         return;
    //     }

    //     // 10-digit mobile number validation
    //     if (!/^\d{10}$/.test(formData.mobile)) {
    //         setLoading(false);
    //         Swal.fire("Validation Error", "Mobile number must be exactly 10 digits.", "warning");
    //         return;
    //     }

    //     try {
    //         let response;
    //         // debugger // You can keep this for debugging if needed

    //         if (selectedMember?.id) { // Editing an existing member
    //             response = type === "primary"
    //                 ? await editMember(formData) // Direct call, no dispatch
    //                 : await editLinked(formData); // Direct call, no dispatch
    //         } else { // Adding a new linked member
    //             response = await savelinked(formData); // Direct call, no dispatch
    //         }

    //         // debugger // You can keep this for debugging if needed

    //         // Assuming editMember, savelinked, editLinked directly return the API response
    //         // and that successful responses have a 'status' property, e.g., response.status
    //         if (response?.status === 200) { // Check for status directly
    //             // debugger // You can keep this for debugging if needed
    //             Swal.fire("Success", `${selectedMember ? "Member updated" : "Member saved"} successfully!`, "success");
    //             reloadData();
    //             setIsModalOpen(false);
    //         } else {
    //             // debugger // You can keep this for debugging if needed
    //             // Handle API error messages if available in response.message or similar
    //             const errorMessage = response?.message || "Operation failed!";
    //             Swal.fire("Error", errorMessage, "error");
    //         }
    //     } catch (err) {
    //         console.error("Submission error:", err);
    //         Swal.fire("Error", "Something went wrong! Please try again.", "error");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            style={{
                overlay: { background: "rgba(0, 0, 0, 0.5)" },
                content: {
                    width: "90%", // Adjusted for better responsiveness
                    maxWidth: "500px", // Max width for larger screens
                    margin: "auto",
                    padding: "20px",
                    borderRadius: "10px",
                    overflowY: "auto", // Enable scrolling for long forms
                    maxHeight: "90vh" // Limit modal height
                }
            }}
        >
            <div className="modal-header bg-primary text-white d-flex justify-content-between align-items-center p-3">
                <h5 className="mb-0">{selectedMember ? "Edit Member" : "Add Member"}</h5>
                <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={() => setIsModalOpen(false)}></button>
            </div>

            <div className="modal-body p-3">
                {error && <p className="text-danger text-center">{error}</p>}

                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="firstname">
                                <Form.Label style={{ fontSize: "12px" }}>First Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="firstname"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    required
                                    style={{ fontSize: "12px" }}
                                    readOnly={!edit && selectedMember?.id}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="lastname">
                                <Form.Label style={{ fontSize: "12px" }}>Last Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleChange}

                                    style={{ fontSize: "12px" }}
                                    readOnly={!edit && selectedMember?.id}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label style={{ fontSize: "12px" }}>Email <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    style={{ fontSize: "12px" }}
                                    readOnly={edit && selectedMember?.id}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="mobile">
                                <Form.Label style={{ fontSize: "12px" }}>Mobile <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    required
                                    pattern="[0-9]{10}"
                                    title="Mobile number must be exactly 10 digits"
                                    style={{ fontSize: "12px" }}
                                    readOnly={!edit && selectedMember?.id}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3" controlId="addressline1">
                        <Form.Label style={{ fontSize: "12px" }}>Address Line 1 <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="addressline1"
                            value={formData.addressline1}
                            onChange={handleChange}
                            required
                            style={{ fontSize: "12px" }}
                            readOnly={!edit && selectedMember?.id}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="addressline2">
                        <Form.Label style={{ fontSize: "12px" }}>Address Line 2 </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="addressline2"
                            value={formData.addressline2}
                            onChange={handleChange}
                            style={{ fontSize: "12px" }}
                            readOnly={!edit && selectedMember?.id}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="addressline3">
                        <Form.Label style={{ fontSize: "12px" }}>Address Line 3</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="addressline3"
                            value={formData.addressline3}
                            onChange={handleChange}
                            style={{ fontSize: "12px" }}
                            readOnly={!edit && selectedMember?.id}
                        />
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="state">
                                <Form.Label style={{ fontSize: "10px" }}>State <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    style={{ width: "95%", fontSize: "10px", color: "gray" }}
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                    readOnly={!edit && selectedMember?.id} // Apply readOnly to select if not in edit mode
                                >
                                    <option value="">Select State</option>
                                    {usStates.map((state) => (
                                        <option key={state.abbreviation} value={state.abbreviation}>
                                            {state.name} ({state.abbreviation})
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="zipcode">
                                <Form.Label style={{ fontSize: "12px" }}>Zip Code <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="zipcode"
                                    value={formData.zipcode}
                                    onChange={handleChange}
                                    required
                                    style={{ fontSize: "12px" }}
                                    readOnly={!edit && selectedMember?.id}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {localStorage.getItem("role")?.trim().toLowerCase() === "admin" && (
                        <>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="join_date">
                                        <Form.Label style={{ fontSize: "12px" }}>Join Date</Form.Label>
                                        <Form.Control
                                            type="text" // Changed to type="date" for date input
                                            name="join_date"
                                            value={formData.join_date}
                                            onChange={handleChange}
                                            style={{ fontSize: "12px" }}
                                            
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="role">
                                        <Form.Label style={{ fontSize: "10px" }}>Role</Form.Label>
                                        <Form.Control
                                            as="select"
                                            style={{ width: "95%", fontSize: "10px", color: "gray" }}
                                            name="role"
                                            value={formData.role}
                                            onChange={handleChange}
                                            readOnly={!edit} // Admin can edit if `edit` is true
                                        >
                                            <option value="">Select Role</option>
                                            {rolelist.map((roleOption) => (
                                                <option key={roleOption} value={roleOption}>
                                                    {roleOption}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3" controlId="validupto">
                                <Form.Label style={{ fontSize: "12px" }}>Valid Upto</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="validupto"
                                    value={formData.validupto}
                                    onChange={handleChange}
                                    style={{ fontSize: "12px" }}
                                    readOnly={!edit} // Admin can edit if `edit` is true
                                />
                            </Form.Group>




                        </>
                    )}

                    {formData.id != "0" && (
                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                required
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </Form.Select>
                        </Form.Group>)}

                    <div className="d-flex justify-content-center mt-4">
                        <Button type="submit" variant="primary" disabled={loading} style={{ width: "100px" }}>
                            {loading ? "Saving..." : selectedMember ? "Update" : "Submit"}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

export default Membersmodal;